import styled from 'styled-components';

export const HeaderButton = styled.button`
  /* Base styling */
  display: flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  cursor: pointer;
  transition: 0.3s;
  position: relative;
  white-space: nowrap;
  
  /* Theme colors - using purple brand color */
  background: #8850FF;
  color: white;
  
  /* Hover effects - consistent with other buttons */
  &:hover {
    background: #7B46F6;
  }
  
  /* Active/pressed state */
  &:active {
    background: #6B35F9;
  }
  
  /* Expanded state styling - minimal and clean */
  background: ${props => props.isExpanded ? '#6B35F9' : '#8850FF'};
  transform: ${props => props.isExpanded ? 'scale(0.98)' : 'scale(1)'};
  box-shadow: ${props => props.isExpanded 
    ? '0 0 20px rgba(136, 80, 255, 0.6), 0 0 40px rgba(136, 80, 255, 0.3)' 
    : 'none'
  };
  
  /* Focus styles for accessibility */
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(136, 80, 255, 0.4);
  }
  
  /* Disabled state (if needed) */
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    
    &:hover {
      background: #8850FF;
    }
  }
  
  /* Icon styling */
  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    opacity: 0.9;
  }
`;

export const ButtonText = styled.span`
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.02em;
  
  /* Hide text on smaller screens to save space */
  @media (max-width: 768px) {
    display: none;
  }
`;